import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import api from '../utils/api';

export default function IndicadoresRepro() {
  const [ind, setInd] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reproducao/indicadores').then(r => setInd(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Carregando...</div>;

  const cards = [
    { label: 'Taxa de Prenhez', value: `${ind?.prenhez?.taxa || 0}%`, sub: `${ind?.prenhez?.prenhas || 0} prenhas de ${ind?.prenhez?.total || 0}`, cor: '#16A34A' },
    { label: 'Taxa de Natalidade', value: `${ind?.natalidade?.partos ? ((ind?.natalidade?.nascidos / ind?.natalidade?.partos) * 100).toFixed(1) : 0}%`, sub: `${ind?.natalidade?.nascidos || 0} nascidos em ${ind?.natalidade?.partos || 0} partos`, cor: '#2563EB' },
    { label: 'Média Crias/Parto', value: parseFloat(ind?.natalidade?.media_crias || 0).toFixed(2), sub: 'índice de prolificidade', cor: '#7C3AED' },
    { label: 'Intervalo Entre Partos', value: ind?.intervalo_medio ? `${Math.round(ind.intervalo_medio)} dias` : '—', sub: 'média do rebanho', cor: '#D97706' },
  ];

  return (
    <div>
      <div className="page-header"><h1>Indicadores Reprodutivos</h1><p>Índices zootécnicos dos últimos 12 meses</p></div>
      <div className="stats-grid">
        {cards.map(c => (
          <div key={c.label} className="stat-card" style={{ borderLeft: `4px solid ${c.cor}` }}>
            <div className="stat-label">{c.label}</div>
            <div className="stat-value" style={{ color: c.cor }}>{c.value}</div>
            <div className="stat-sub">{c.sub}</div>
          </div>
        ))}
      </div>
      <div className="card">
        <h3 style={{ marginBottom: 16 }}>Resumo Reprodutivo</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
          <div>
            <h4 style={{ marginBottom: 12, fontSize: 14, color: 'var(--text-secondary)' }}>Coberturas (12 meses)</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                ['Total coberturas', ind?.prenhez?.total || 0],
                ['Prenhas', ind?.prenhez?.prenhas || 0],
                ['Taxa prenhez', `${ind?.prenhez?.taxa || 0}%`],
              ].map(([label, val]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border-color)' }}>
                  <span style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{label}</span>
                  <strong>{val}</strong>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 style={{ marginBottom: 12, fontSize: 14, color: 'var(--text-secondary)' }}>Partos (12 meses)</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                ['Total partos', ind?.natalidade?.partos || 0],
                ['Crias nascidas vivas', ind?.natalidade?.nascidos || 0],
                ['Média crias/parto', parseFloat(ind?.natalidade?.media_crias || 0).toFixed(2)],
                ['Intervalo entre partos', ind?.intervalo_medio ? `${Math.round(ind.intervalo_medio)}d` : '—'],
              ].map(([label, val]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border-color)' }}>
                  <span style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{label}</span>
                  <strong>{val}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
